<template>
  <div class="row align-items-end">
    <div class="col-xl-3 col-lg-4 col-sm-6">
      <label class="w-100">
        {{ $t('modal.form.start_date') }}
        <input type="date" class="form-control" v-model="fetch.pagination.start_date" :max="nowDate()" @input="fetchData">
      </label>
    </div>
    <div class="col-xl-3 col-lg-4 col-sm-6">
      <label class="w-100">
        {{ $t('modal.form.end_date') }}
        <input type="date" class="form-control" v-model="fetch.pagination.end_date" @input="fetchData">
      </label>
    </div>
    <div class="col-xl-3 col-lg-4 col-sm-6">
      <label class="w-100">
        {{ $t('modal.form.driver.label') }}
        <v-select class="select-control" v-model="fetch.pagination.driverId" :options="options.driver" :reduce="(options) => options.id" label="full_name" @input="fetchData"></v-select>
      </label>
    </div>
    <div class="col-xl-3 col-lg-4 col-sm-6 ms-auto">
      <div class="h-auto mb-2 w-100 d-flex align-items-center justify-content-end">
        <button type="button" class="btn btn-success" @click="uploadExcelForm"><i class="bx bx-upload font-size-16 align-middle me-2"></i> Excel </button>
      </div>
    </div>
    <b-card>
      <b-card-body class="p-0">
        <div class="_table">
          <b-table :fields="fetch.fields" :items="fetch.items" :busy="fetch.loading" >
            <template #table-busy>
              <div class="text-center text-primary my-2">
                <b-spinner class="align-middle me-3"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
            <template #cell(numbers)="{item}">
              <div v-if="item.client">
                <span v-for="(n, idx) in item.client.numbers" :key="idx">{{n.mobile | VMask('###(##) ### ## ##')}}</span>
              </div>
            </template>
          </b-table>
        </div>
      </b-card-body>
    </b-card>
    <b-pagination v-model="fetch.pagination.page" :total-rows="fetch.total" :per-page="fetch.pagination.pageSize" @input="fetchData"></b-pagination>
  </div>
</template>

<script>
import {getActiveOrderClients} from '@/api/endpoints/doubtfull-clients';
import {getDriver} from '@/api/endpoints/users';
import {uploadActiveOrdersExcel} from '@/api/endpoints/upload-excel';
import moment from 'moment'
export default {
  name: 'ManagerWaterRounds',
  data() {
    return {
      fetch: {
        items: [],
        fields: [
          {key: "client.contract_number", label: "#"},
          {key: "client.full_name", label: this.$t("table.full_name.label"),},
          {key: "client.address", label: this.$t("table.address.label"),},
          {key: "numbers", label: this.$t("table.numbers.label"), class: "width_100",},
          {key: "client.bottles_count", label: this.$t("table.bottles_count")},
          {key: "client.driver.full_name", label: this.$t("table.driver.label")},
          {key: "sum", label: "Buyurtmalar soni"},
        ],
        pagination: {
          page: 1,
          pageSize: 25,
          end_date: moment(new Date()).format('YYYY-MM-DD'),
          start_date: moment(new Date()).format('YYYY-MM-DD'),
          driverId: null,
        },
        total: 1,
        loading: false,
      },
      options: {
        driver: []
      }
    }
  },
  created() {
    this.fetchData();
    this.nowDate();
    this.fetchDriver();
  },
  methods: {
    fetchData() {
      this.fetch.loading = true;
      getActiveOrderClients(this.fetch.pagination)
          .then(response => {
            this.fetch.items = response.data.data.data;
            this.fetch.total = response.data.data.total;
          })
          .catch(err => {
            // eslint-disable-next-line no-console
            console.log(err);
          })
          .finally(() => {
            this.fetch.loading = false;
          })
    },
    nowDate() {
      return moment(new Date()).format('YYYY-MM-DD')
    },
    fetchDriver() {
      getDriver().then(response => {
        this.options.driver = response.data.data;
      })
    },
    uploadExcelForm() {
      uploadActiveOrdersExcel({start_date: this.fetch.pagination.start_date, end_date: this.fetch.pagination.end_date, driver_id: this.fetch.pagination.driverId}).then(({data}) => {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'orders-total.xlsx');
        document.body.appendChild(link);
        link.click()
      })
    },
  }
}
</script>
